import { Component, OnDestroy, OnInit } from '@angular/core';
import { HighlightItem, HighlightService, HighlightType } from '../../services/highlight.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-highlight-navigation',
    templateUrl: './highlight-navigation.component.html',
    styleUrls: ['./highlight-navigation.component.scss'],
    standalone: false
})
export class HighlightNavigationComponent implements OnInit, OnDestroy {
    highlightItems: HighlightItem[] = [];
    currentIndex: number = -1;
    isActive: boolean = false;
    showOnlyMatched: boolean = false;
    
    private subscriptions: Subscription[] = [];
    
    constructor(private highlightService: HighlightService) {}
    
    ngOnInit() {
        // Vurgulanan öğeleri takip et
        this.subscriptions.push(
            this.highlightService.highlightItems$().subscribe(items => {
                this.highlightItems = items;
            })
        );
        
        // Aktif vurgulama indeksini takip et
        this.subscriptions.push(
            this.highlightService.currentHighlightIndex$().subscribe(index => {
                this.currentIndex = index;
            })
        );
        
        // Highlight durumu aktifliğini takip et
        this.subscriptions.push(
            this.highlightService.highlightActive$().subscribe(active => {
                this.isActive = active;
            })
        );
        
        // Sadece eşleşen kelimeyi göster/tüm satırı göster durumunu takip et
        this.subscriptions.push(
            this.highlightService.showOnlyMatched$().subscribe(showOnlyMatched => {
                this.showOnlyMatched = showOnlyMatched;
            })
        );
    }
    
    /**
     * Bir sonraki vurgulanan öğeye git
     */
    nextHighlight(): void {
        this.highlightService.nextHighlight();
    }
    
    /**
     * Bir önceki vurgulanan öğeye git
     */
    previousHighlight(): void {
        this.highlightService.previousHighlight();
    }
    
    /**
     * Vurgulamaları kapat
     */
    closeHighlights(): void {
        this.highlightService.clearHighlights();
        
        // URL'den highlight parametrelerini kaldır
        this.highlightService.clearHighlightParams();
    }
    
    /**
     * Sadece eşleşen kelimeyi gösterme/tüm satırı gösterme durumunu değiştirir
     */
    toggleShowOnlyMatched(): void {
        this.highlightService.toggleShowOnlyMatched();
    }
    
    /**
     * Yeni bir metin araması başlat
     */
    searchText(text: string): void {
        if (text && text.trim() !== '') {
            this.highlightService.setHighlightParams(HighlightType.TEXT, text.trim());
        }
    }
    
    /**
     * ID ile highlight yap
     */
    highlightById(id: string): void {
        if (id && id.trim() !== '') {
            this.highlightService.setHighlightParams(HighlightType.ID, id.trim());
        }
    }
    
    /**
     * Anchor ile highlight yap
     */
    highlightByAnchor(anchor: string): void {
        if (anchor && anchor.trim() !== '') {
            this.highlightService.setHighlightParams(HighlightType.ANCHOR, anchor.trim());
        }
    }
    
    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
